import './Page.css';
import LoserOffer from "../componetns/menu/infoBanner/loserOffrer/LoserOffer";
import WinnerOffer from "../componetns/menu/infoBanner/winnerOffrer/WinnerOffer";
import {config} from "../config";

function InfoBanner() {
    return (
        <div className="InfoBannerContainer">
            {config.isNutaku ? <LoserOffer /> : <WinnerOffer />}
        </div>
    );
}

export default InfoBanner;
